import React from "react";

// Icon Styles
const iconStyle = { 
  color: "#333",
  transform: "scale(50%) translate(60%, 40%)",
  margin: "0"
};

// A portal where recovered COVID-19 patients can share their resources.
const GitCard = (props) => {
  return (
    <>
      <div data-aos="fade-up-right" data-aos-delay="300" className="github-card" style={
        {
          flexBasis: "30%",
          height: "auto",
          border: "1px solid #007bff",
          borderRadius: "8px",
          boxShadow: "5px 5px 5px 0px rgb(158, 155, 155)"
        }
      }>
        <a href={props.repoLink} target="_blank" rel="noopener noreferrer"><h5>{props.title}</h5></a>
        <p style={{
          marginTop: 0
        }}>{props.description}
        <br />
        {
          props.pageUrl === "" ? "" : <>
            <a href={props.pageUrl} target="_blank" rel="noopener noreferrer">
              HomePage
            </a>
          </>
           
        }
        </p>
        <br />
        <div style={{ position: "absolute",
                      bottom: "0",
                      padding: "1rem",
                      width: "90%",
        }}>
            {
              props.language !== null?
              <span className="github-card__meta">
                <span
                  className="github-card_language-icon"
                  style={{color:props.color}}
                >
                ●
                </span>{" "}
                {props.language}
              </span>
              :
              <span>
                
              </span>
            }
          <span className="github-card__meta">
            <i className="fa fa-star" style={iconStyle}></i>
            {" "}
            {props.star}
          </span>
          <span className="github-card__meta">
            <i className="fa fa-code-fork" style={iconStyle}></i>
            {" "}
            {props.fork}
          </span>
        </div>
      </div>
    </>
  );
};

export default GitCard;
